import { render } from "./DocumentsGrid.vue?vue&type=template&id=a84b6cfe&scoped=true"
import script from "./DocumentsGrid.vue?vue&type=script&lang=js"
export * from "./DocumentsGrid.vue?vue&type=script&lang=js"

import "./DocumentsGrid.vue?vue&type=style&index=0&id=a84b6cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84b6cfe"]])

export default __exports__